<script lang="ts">
  import type { IFormTextNode, PartialNode } from "@shared/common/node/type";
  import { stringTemplateHelper } from "@shared/common/utils/string-template-helper";
  import detectReaction from "../../actions/detect-reaction";
  import { getCurrentDocumentNode, getStore } from "../../context";

  const { reactionEventListener, dataMap, t } = getStore();

  const documentNode = getCurrentDocumentNode();

  export let node: PartialNode<IFormTextNode>;
</script>

<div
  class="text-content"
  use:detectReaction={{
    node,
    onAction: reactionEventListener,
    documentNode,
  }}
>
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  {@html stringTemplateHelper({ mode: "VIEW", t: $t }).render(
    node.content || "",
    $dataMap
  )}
</div>

<style>
  /* 참고: front-app 의 editor-node 스타일도 함께 수정 필요 */

  .text-content {
    font-size: var(--cb-text-lg);
    line-height: var(--cb-line-height-lg);
    color: rgba(var(--cb-form-font-color), 1);
    text-align: left;
    color: rgba(var(--cb-form-font-color), 0.85);
    user-select: initial;
    font-size: calc(var(--cb-form-font-size) * 0.875);
    background-color: white;
  }

  .text-content :global(ul li) {
    padding-left: 1.5em;
  }

  .text-content :global(ul li::before) {
    content: "\2022";
    margin-left: -1.5em;
    margin-right: 0.3em;
    text-align: right;
    display: inline-block;
    white-space: nowrap;
    width: 1.2em;
  }
</style>
